import { render, staticRenderFns } from "./AssociationDes.vue?vue&type=template&id=78c85117&scoped=true"
import script from "./AssociationDes.vue?vue&type=script&lang=js"
export * from "./AssociationDes.vue?vue&type=script&lang=js"
import style0 from "./AssociationDes.vue?vue&type=style&index=0&id=78c85117&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c85117",
  null
  
)

export default component.exports